/*eslint-disable*/
import Splide from '@splidejs/splide';
export default {
  init() {
    const singleEventSlider = new Splide('.splide--single-event', {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      pagination: true,
      arrows: false,
      autoplay: false,
      interval: 7000,
    }).mount();

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
